<template>
    <div class="plan-summary" v-if="cart">
        <h2>Your Plans</h2>
        <p>The plans you enrolled in. Contact your representative if anything here needs to change.</p>
        <div class="plan-summary-grid">
            <div class="plan-summary-block">
                <h3>Enrollment</h3>
                <ul>
                    <li v-if="cart.effective_date"><span>Effective Date</span><strong>{{ cart.effective_date }}</strong></li>
                    <li v-if="cart.tier"><span>Tier</span><strong>{{ tierLabel(cart.tier) }}</strong></li>
                    <li v-if="cart.group_name"><span>Group</span><strong>{{ cart.group_name }}</strong></li>
                </ul>
            </div>
            <div class="plan-summary-block">
                <h3>Enrolled In</h3>
                <ul v-if="cart.plans.length">
                    <li v-for="(plan, index) in cart.plans" :key="index"><strong>{{ plan }}</strong></li>
                </ul>
                <p v-else>No active plans found.</p>
            </div>
            <div class="plan-summary-block" v-if="cart.payment">
                <h3>Payment</h3>
                <ul>
                    <li><span>Membership Processing Fee</span><strong>{{ cart.payment.processing_fee }}</strong></li>
                    <li v-if="cart.payment.card_fee"><span>Payment Service Fee</span><strong>{{ cart.payment.card_fee }}</strong></li>
                    <li><span>First Month Total</span><strong>{{ cart.payment.first_month_total }}</strong></li>
                    <li><span>Recurring Monthly Total</span><strong>{{ cart.payment.recurring_monthly_total }}</strong></li>
                    <li v-if="cart.payment.payment_method"><span>Payment Method</span><strong>{{ paymentLabel(cart.payment.payment_method) }}</strong></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import reviewApi from '@/resource/memberReviewApi';

const TIERS = {
    IO: 'Member Only',
    IS: 'Member + Spouse',
    IC: 'Member + Child(ren)',
    IF: 'Family',
};

const PAYMENT_METHODS = {
    eft: 'Bank Account (EFT)',
    cc: 'Credit Card',
    list_bill: 'List Bill',
};

export default {
    name: 'PlanSummary',
    data: () => ({
        cart: null,
    }),
    mounted() {
        this.load();
    },
    methods: {
        // Read-only and informational: if it can't load, just don't show it
        // (an expired session is still handled by memberReviewApi).
        load() {
            reviewApi.getCart()
                .then((res) => {
                    const cart = (res.data && res.data.data) || null;
                    if (cart) {
                        cart.plans = cart.plans || [];
                    }
                    this.cart = cart;
                })
                .catch(() => {
                    this.cart = null;
                });
        },
        tierLabel(tier) {
            return TIERS[tier] || tier;
        },
        paymentLabel(method) {
            return PAYMENT_METHODS[String(method).toLowerCase()] || method;
        },
    },
};
</script>
